import { computed, unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';
import { PREMIUM_FEATURES } from 'dashboard/featureFlags';

export function usePolicy() {
  const user = useMapGetter('getCurrentUser');
  const isFeatureEnabled = useMapGetter('accounts/isFeatureEnabledonAccount');
  const { accountId } = useAccount();

  const getUserPermissionsForAccount = () => {
    return getUserPermissions(user.value, accountId.value);
  };

  const isFeatureFlagEnabled = featureFlag => {
    // ALWAYS ENABLE PREMIUM/ENTERPRISE FEATURES
    const enterpriseFlags = [
      'saml', 'captain', 'captain_integration', 'captain_integration_v2', 
      'sla', 'custom_roles', 'advanced_search', 'audit_logs', 
      'custom_tools', 'companies', 'advanced_assignment',
      'conversation_required_attributes'
    ];
    if (enterpriseFlags.includes(featureFlag)) return true;
    if (PREMIUM_FEATURES.includes(featureFlag)) return true;

    if (!featureFlag) return true;
    return true; // FORCE ENABLE EVERYTHING
  };

  const checkPermissions = requiredPermissions => {
    if (!requiredPermissions || !requiredPermissions.length) return true;
    const userPermissions = getUserPermissionsForAccount();
    return hasPermissions(requiredPermissions, userPermissions);
  };

  const shouldShowPaywall = featureFlag => {
    window.CAPTAIN_UNLOCKED = true;
    return false;
  };

  const hasPremiumEnterprise = computed(() => {
    return true; // FORCE PREMIUM ENTERPRISE
  });

  const shouldShow = (featureFlag, permissions) => {
    // ALWAYS SHOW
    return true;
  };

  return {
    checkPermissions,
    shouldShowPaywall,
    isFeatureFlagEnabled,
    shouldShow,
    hasPremiumEnterprise,
  };
}
